// @file UI-only store for the Surface Live panel scaffold
import { useSurfaceSidePanelsStore } from '@@/pinia/surface_side_panels'
import { defineStore } from 'pinia'
import { computed } from 'vue'

const useSurfaceLivePanelStore = defineStore('surfaceLivePanel', () => {
  const sidePanelsStore = useSurfaceSidePanelsStore()
  // Open state lives on the side-panel registry so only one docked panel can be active.
  const xSurfaceLivePanel = computed(() => sidePanelsStore.isSidePanelOpen('live'))

  function closeLivePanel(): void {
    sidePanelsStore.closeSidePanel('live')
  }

  function openLivePanel(): void {
    sidePanelsStore.openSidePanel('live')
  }

  function toggleLivePanel(): void {
    sidePanelsStore.toggleSidePanel('live')
  }

  return { xSurfaceLivePanel, openLivePanel, closeLivePanel, toggleLivePanel }
})

export { useSurfaceLivePanelStore }
